// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PlayButtonOverlay_overlay__qjXa8"};